var _circle, _circle2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKaspiSuccess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 180,
    height: 180,
    viewBox: "0 0 180 180",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 90,
    cy: 90,
    r: 85.68,
    stroke: "#B8E986",
    strokeOpacity: 0.36,
    strokeWidth: 8.64
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 89.9998,
    cy: 90.0002,
    r: 57.4699,
    fill: "#A2DA5A"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M119.916 71.6582C120.554 70.8263 120.396 69.6352 119.564 68.9978C118.732 68.3604 117.541 68.5181 116.904 69.3501L85.2247 110.697L65.9082 93.0561C65.1344 92.3494 63.9341 92.4038 63.2274 93.1777C62.5206 93.9515 62.575 95.1518 63.3489 95.8585L84.1623 114.867C84.2114 114.914 84.2634 114.958 84.3185 115C85.0231 115.54 85.9854 115.51 86.6507 114.982C86.7294 114.92 86.8042 114.85 86.8741 114.774C86.9202 114.723 86.963 114.671 87.0027 114.617L119.916 71.6582Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKaspiSuccess);
export default __webpack_public_path__ + "static/media/kaspi-success.7e31004b32c70a46462f590167a63177.svg";
export { ForwardRef as ReactComponent };